export default class LayerConfiguration {
    constructor(attributes) {
        this.key = attributes.key
        this.renderer = attributes.renderer
        this.label = attributes.label
        this.position = attributes.position
        this.optional = attributes.optional
        this.enabled_by_default = attributes.enabled_by_default
        this.options = attributes.options || {}
        this.data = attributes.data || []
    }

    withData(data) {
        return new LayerConfiguration({ ...this, data })
    }
}
